import React from 'react';
interface HighlightPoint {
  hook: string;
  text: string;
}
const points: HighlightPoint[] = [{
  hook: '¿Dolores sin causa clara?',
  text: 'Decodifica los órganos más vulnerables según tu fecha de nacimiento.'
}, {
  hook: '¿Patrones repetitivos?',
  text: 'Identifica el código emocional que dispara tus síntomas físicos.'
}, {
  hook: '¿Sin respuestas?',
  text: 'Recibe tu receta exacta de cristales y frecuencias según tu número maestro.'
}];
export function BonusHighlight() {
  return <section className="bg-black px-5 py-14 sm:px-8" data-id="element-24" data-mp="y5j03vwk355o">
      <div className="mx-auto grid max-w-5xl items-center gap-9 md:grid-cols-[0.85fr_1.15fr] md:gap-12" data-id="element-25" data-mp="126l1ojdy3tat">
        <div className="relative" data-id="element-26" data-mp="1755zkc5q60w3">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/df2df78a-d687-4c41-8c09-7c046c57416c.jpg" alt="Maqueta del informe digital Numerología Cabalística y Salud, con números cabalísticos dorados y un mapa energético del cuerpo" className="mx-auto w-full max-w-[300px] rounded-lg md:max-w-none" style={{
          filter: 'drop-shadow(0 22px 45px rgba(26, 74, 46, 0.55))'
        }} data-id="element-27" data-mp="1767dcoe4l1hi" />
        </div>

        <div data-id="element-28" data-mp="3i525780fbj73">
          <span className="inline-block rounded-full border border-gold/60 bg-gold/10 px-3 py-1.5 text-[10px] font-black uppercase tracking-[0.1em] text-gold sm:text-[11px]" data-id="element-29" data-mp="3i4iykng84h8d">
            🔥 Súper Bono #3 — Gratis solo hoy
          </span>

          <h2 className="mt-4 font-display text-[24px] font-bold uppercase leading-tight text-white sm:text-[32px]" data-id="element-30" data-mp="395ylq2xch1s2">
            Tu nombre sabe lo que tu médico no ve
          </h2>
          <p className="mt-3 text-[15px] leading-relaxed text-gold/90 sm:text-[16px]" data-id="element-31" data-mp="2zfm3ihd05kp3">
            Lo que los análisis clínicos no detectan, tu vibración personal lo revela.
          </p>

          <ul className="mt-6 space-y-4 border-t border-white/10 pt-6" data-id="element-32" data-mp="2pflfii46ugek">
            {points.map(p => <li key={p.hook} className="flex gap-3" data-id="element-33" data-mp="2lgcldc58kgih">
                <span aria-hidden="true" className="mt-0.5 text-[14px] text-gold" data-id="element-34" data-mp="2au7lckj15j1e">
                  ✦
                </span>
                <p className="text-[14px] leading-relaxed text-white/75 sm:text-[15px]" data-id="element-35" data-mp="2fu3pqkvn3chh">
                  <strong className="font-black text-white" data-id="element-36" data-mp="21u1az7imoz6g">{p.hook}</strong> {p.text}
                </p>
              </li>)}
          </ul>

          <p className="mt-6 flex items-center justify-center rounded-full bg-gold/90 px-5 py-3 text-center text-[12px] font-black uppercase leading-snug tracking-[0.08em] text-ink sm:text-[13px]" data-id="element-37" data-mp="26ugobz2wu6of">
            El complemento perfecto para tu Manual de Autosanación
          </p>
        </div>
      </div>
    </section>;
}